import { useState } from 'react'
import { Check, Link } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { appRoutes } from '../../lib/routes'
import './CardCopyLink.css'

export default function CardCopyLink({ cardId }) {
    const { t } = useTranslation()
    const [copied, setCopied] = useState(false)
    const [manual, setManual] = useState(false)
    const [busy, setBusy] = useState(false)
    const url = new URL(appRoutes.home, window.location.origin)
    url.searchParams.set('card', cardId)
    const link = url.href
    const label = t('card.copyLink', { defaultValue: 'Copiază link' })

    const copy = async () => {
        setBusy(true)
        setCopied(false)
        try {
            if (!navigator.clipboard?.writeText) throw new Error('clipboard_unavailable')
            await navigator.clipboard.writeText(link)
            setCopied(true)
            setManual(false)
        } catch {
            setManual(true)
        } finally { setBusy(false) }
    }

    return (
        <div className="cd-copy-link">
            <button type="button" className="btn btn-secondary btn-sm" onClick={copy} disabled={busy} title={label}>
                {copied ? <Check size={14} /> : <Link size={14} />}
                <span aria-live="polite">{copied ? t('card.linkCopied', { defaultValue: 'Link copiat' }) : label}</span>
            </button>
            {manual ? <div className="cd-copy-link-manual">
                <label>
                    {t('card.copyLinkManual', { defaultValue: 'Copiază linkul de mai jos:' })}
                    <input aria-label={label} readOnly value={link} autoFocus onFocus={(event) => event.target.select()} onClick={(event) => event.currentTarget.select()} />
                </label>
            </div> : null}
        </div>
    )
}
